/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseGssOccasionPeopleResponseData } from './genericApiResponseGssOccasionPeopleResponseData';
import type { GenericApiResponseGssOccasionPeopleResponseMessage } from './genericApiResponseGssOccasionPeopleResponseMessage';
import type { GenericApiResponseGssOccasionPeopleResponsePagination } from './genericApiResponseGssOccasionPeopleResponsePagination';
import type { GenericApiResponseGssOccasionPeopleResponseError } from './genericApiResponseGssOccasionPeopleResponseError';

export interface GenericApiResponseGssOccasionPeopleResponse {
  data?: GenericApiResponseGssOccasionPeopleResponseData;
  message?: GenericApiResponseGssOccasionPeopleResponseMessage;
  pagination?: GenericApiResponseGssOccasionPeopleResponsePagination;
  error?: GenericApiResponseGssOccasionPeopleResponseError;
  statusCode?: number;
}
